export enum enBannerHTML5 {
  Live = 'https://appsport.snai.it/routing/live',
  Sport = 'https://appsport.snai.it',
  Ippica = 'https://appsport.snai.it/routing/ippica',
  // Virtual = 'https://appsport.snai.it/routing/virtual',
}

export type BannerHTML5Props = {
  url?: string;
  text?: string;
  buttonLabel?: string;
};

export { BannerHTML5 } from './BannerHTML5';
